import React, { useEffect } from "react";
import ExploreRightSideContent from "./explore-right-side-content/ExploreRightSideContent";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { exploreStore } from "store/exploreStore";
import { AppLog } from "services";
import { StatusMsg } from "utils";
import LeftSideConetnetUserFollowersAndReachs from "components/app/left-side-contents/LeftSideContentUserFollowersAndReachs";

export default function ExploreLayout({ children }: { children: React.ReactNode }) {
  const { topTenFollowers, initializePage, topTenReachs, topTenFollowerLoading, topTenReachLoading } = exploreStore();

  useEffect(() => {
    const loadInitialPage = async () => {
      try {
        await initializePage();
      } catch (error) {
        AppLog.show({
          message: `[loadInitialPage]`,
          status: StatusMsg.error,
          error,
        });
      }
    };
    loadInitialPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex">
      <div className="hidden md:block w-[450px] lg:w-[450px] sticky right-0 top-[80px] left-0 h-[calc(100vh-80px)] z-0 pe-2">
        <ScrollArea className="w-full h-full">
          {/* <ExploreLeftSideContent /> */}
          {/* JK EDIT */}
          <LeftSideConetnetUserFollowersAndReachs
            topTenFollowers={topTenFollowers}
            topTenFollowerLoading={topTenFollowerLoading}
            topTenReachs={topTenReachs}
            topTenReachLoading={topTenReachLoading}
          />

          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </div>
      <div className="w-full z-0 p-2 md:p-0">{children}</div>
      <div className="hidden md:block w-[410px] lg:w-[410px] sticky right-0 top-[80px] left-0 h-[calc(100vh-80px)] z-0 overflow-auto">
        <ScrollArea className="w-full h-full">
          <ExploreRightSideContent />
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      </div>
    </div>
  );
}
